import styled from "styled-components";

export const LiveStreamSlideStatusBadgeBox = styled.div`
    display: inline-flex;
    padding: 4px 12px;
    align-items: center;
    gap: 6px;
    border-radius: 32px;
    background: rgba(255, 255, 255, 0.40);

    backdrop-filter: blur(2.5px);
`;